module.exports = __webpack_public_path__ + "static/avenir-next-medium-22ee3f059103a259bddd0845881cf2cb.woff";